import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, Grid, Typography, Box, Container, Button, FormLabel, RadioGroup, Radio, FormGroup, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedChangeWithError } from "./common/useValidatedChangeWithError.js";
import { decimalValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp4Sub = ({exhibitorId: propExhibitorId, isModal=false, setFormModalOpen, isCorpModal=false, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_4_name: "",
    user_4_department: "",
    user_4_phone: "",
    user_4_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    bolt_thin: 0,
    bolt_length: 0,
    bolt_number: 0,
    organize_company: "",
    organize_name: "",
    organize_tel: "",
    organize_address: "",
    organize_zip: "",
    alfa_text: "",
  });
  const [errors, setErrors] = useState({
    bolt_thin: "",
    bolt_length: "",
    bolt_number: "",
  });

  const handleValidatedChange = useValidatedChangeWithError(
    setFormData,
    setErrors
  );
  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const [corrections, setCorrections] = useState({
    user_4_info: false,
    invoice_info: false,
    const_info: false,
    contractor_info: false,
  });

  const field_name_map_O4 = {
    user_4_info: "担当者情報",
    invoice_info: "請求先情報",
    const_info: "工事情報",
    contractor_info: "施工業者情報",
  };

  const [memoText, setMemoText] = useState('');

  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections(prev => ({
      ...prev,
      [fieldKey]: e.target.checked
    }));
  };

  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };

  const handleCorrection = async () => {
    try {
      const selectedFields = Object.entries(corrections)
        .filter(([_, checked]) => checked)
        .map(([field]) => field_name_map_O4[field] || field);

      if (selectedFields.length === 0) {
        alert('修正対象の項目を選択してください');
        return;
      }

      const currentPath = window.location.pathname;

      await api.patch('/api/host-correction', {
        exhibitor_id: exhibitorId,
        form_type: 'o4',
        correction: selectedFields,
        memo: memoText,
        current_path: currentPath,
      });

      // 👇 これ追加
      updateStatus(exhibitorId, 'o4', {
        host: '未確認',
        corporate: '未確認',
      });

      alert('修正リクエスト送信完了');
      setFormModalOpen(false);

      setCorrections(
        Object.fromEntries(Object.keys(corrections).map(k => [k, false]))
      );
      setMemoText('');

    } catch (err) {
      console.error(err);
      alert('修正処理でエラーが発生しました');
    }
  };

  const updateHostStatus = (exhibitorId, formType, newStatus) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              [`${formType}_host_status`]: newStatus,
              [`${formType}_corporate_status`]: newStatus, // ←これ追加
            }
          : ex
      )
    );
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });
      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const exhibitorId = user?.mypage_id ?? propExhibitorId; // nullならpropExhibitorIdを使う

        if (!exhibitorId) return; // 両方なかったら何もせん

        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, [propExhibitorId]);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);
  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_4_name: mypageData.user_name || "",
        user_4_department: mypageData.department || "",
        user_4_phone: mypageData.phone_number || "",
        user_4_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_4_name: "",
        user_4_department: "",
        user_4_phone: "",
        user_4_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchO4InitialData = async () => {
      try {
        const [resStatus, resO4, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/o4submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o4Status = resStatus.data?.o4_status || "";
        const o4Data = resO4.data || {};
        const mypage = resMypage.data || {};

        if (o4Status === "申請しない") {
          setNotApply(true);
          setFormData({
            user_4_name: null,
            user_4_department: null,
            user_4_phone: null,
            user_4_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            bolt_thin: null,
            bolt_length: null,
            bolt_number: null,
            organize_company: null,
            organize_name: null,
            organize_tel: null,
            organize_address: null,
            organize_zip: null,
            alfa_text: null,
          });
          setFieldsDisabled(false);
        } else {
          if (Object.values(o4Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
          })) {
            setFormData(prev => ({
              ...prev,
              ...o4Data,
            }));
            if (
              o4Data.user_4_name === mypage.user_name &&
              o4Data.user_4_department === mypage.department &&
              o4Data.user_4_phone === mypage.phone_number &&
              o4Data.user_4_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o4Data.invoice_company_name === mypage.company_name &&
                o4Data.invoice_user_name === mypage.user_name &&
                o4Data.invoice_email === mypage.email &&
                o4Data.invoice_address === mypage.address &&
                o4Data.invoice_tel === mypage.phone_number &&
                o4Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
          }
          setNotApply(false);
        }
      } catch (err) {
        console.error("O4初期データ取得エラー:", err);
      }
    };

    if (exhibitorId) {
      fetchO4InitialData();
    }
  }, [exhibitorId]);

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_4_name: "",
            user_4_department: "",
            user_4_phone: "",
            user_4_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            bolt_thin: null,
            bolt_length: null,
            bolt_number: null,
            organize_company: null,
            organize_name: null,
            organize_tel: null,
            organize_address: null,
            organize_zip: null,
            alfa_text: null,
          });
      }
  }; 
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

    console.log(formData)

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        const submitErrors = {};

        if (!notApply) {
          if (!formData.user_4_name?.trim()) submitErrors.user_4_name = "入力してください";
          if (!formData.user_4_phone?.trim()) submitErrors.user_4_phone = "入力してください";
          if (!formData.user_4_tel?.trim()) submitErrors.user_4_tel = "入力してください";
          if (!formData.invoice_company_name?.trim()) submitErrors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name?.trim()) submitErrors.invoice_user_name = "入力してください";
          if (!formData.invoice_email?.trim()) submitErrors.invoice_email = "入力してください";
          if (!formData.invoice_address?.trim()) submitErrors.invoice_address = "入力してください";
          if (!formData.invoice_zip?.trim()) submitErrors.invoice_zip = "入力してください";
          if (!formData.invoice_tel?.trim()) submitErrors.invoice_tel = "入力してください";

          if (!formData.bolt_number) submitErrors.bolt_number = "入力してください";
          if (!formData.organize_company?.trim()) submitErrors.organize_company = "入力してください";
          if (!formData.organize_name?.trim()) submitErrors.organize_name = "入力してください";
          if (!formData.organize_tel?.trim()) submitErrors.organize_tel = "入力してください";
          if (!formData.organize_address?.trim()) submitErrors.organize_address = "入力してください";
          if (!formData.organize_zip?.trim()) submitErrors.organize_zip = "入力してください";
        }

        const fieldDisplayNames = {
          user_4_name: "担当者名",
          user_4_department: "担当部署",
          user_4_phone: "会社電話番号",
          user_4_tel: "携帯電話番号",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先担当者名",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          bolt_number: "ボルト本数",
          organize_company: "施工業者会社名",
          organize_name: "施工業者名",
          organize_tel: "施工業者電話番号",
          organize_address: "施工業者住所",
          organize_zip: "施工業者郵便番号",
        };

        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        // 提出用データ整形（user_4_xxx と invoice_xxx は入力があれば値、なければ null）
        const formDataForSend = {
          ...formData,
          user_4_name: formData.user_4_name?.trim() || null,
          user_4_department: formData.user_4_department?.trim() || null,
          user_4_phone: formData.user_4_phone?.trim() || null,
          user_4_tel: formData.user_4_tel?.trim() || null,
          invoice_company_name: formData.invoice_company_name?.trim() || null,
          invoice_user_name: formData.invoice_user_name?.trim() || null,
          invoice_email: formData.invoice_email?.trim() || null,
          invoice_address: formData.invoice_address?.trim() || null,
          invoice_zip: formData.invoice_zip?.trim() || null,
          invoice_tel: formData.invoice_tel?.trim() || null,
          invoice_fax: formData.invoice_fax?.trim() || null,
        };

        const payload = {
          exhibitor_id: exhibitorId,
          formData: formDataForSend,
          notApply: notApply,
        };

        const res = await api.post("/api/submit-o4", payload);

        if (res.status === 200) {
          setNoticeModalOpen(true);
          alert("保存成功");
        } else {
          alert("保存失敗");
        }
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };

    // モーダルの閉じる処理
    const handleCloseNotice = () => {
      const user = JSON.parse(localStorage.getItem("user"));
      setNoticeModalOpen(false);
      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          if (user?.user_id === 0) {
            navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
          } else {
            navigate(`/mypage/${user?.mypage_id}`);
          }
        }
      }, 1000);
    };

    useConfirmBackLogout(navigate);
    useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  return (
      <div>
          {!isCorpModal &&(
            <Header
              title="SDGs 子ども・ユースフェア2026 床面申請"
              companyName={mypageData?.company_name}
            />
          )}
          <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
         <Container sx={{ display: 'flex' }} className="sm-block">
          {!isCorpModal &&(
            <>
            <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
              <Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box
                  className={`menu-item`}
                  onClick={() => {
                      const user = JSON.parse(localStorage.getItem('user'));
                      navigate(`${user?.mypage_url}`);
                    }}
                  >
                    TOP
                  </Box>
                  <Box 
                    className="menu-item"
                    onClick={() => {
                      const user = JSON.parse(localStorage.getItem('user'));
                      navigate(`/mypage-info/${user?.exhibitor_id}`);
                    }}
                  >
                    出展者情報編集
                  </Box>
                  {/* <Box
                    className="menu-group"
                    id="hover-block"
                    onMouseEnter={() => {}}
                    onMouseLeave={() => {}}
                  >
                    <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                      申請フォーム
                    </Box>
                      {showFormMenu && (
                        <Box className="hover-menu">
                          <Typography
                            sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                            className='form-button'
                            onClick={() => navigate('/form-require')}
                          >
                            必須フォーム<br />
                            (全出展者対象)
                          </Typography>
                          <Typography
                            sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                            className='form-button'
                            onClick={() => navigate('/form-optional')}
                          >
                            任意フォーム<br />
                            (該当出展者対象)
                          </Typography>
                        </Box>
                      )}
                  </Box> */}
                  <Box 
                    className="menu-item"
                    onClick={() => {
                      navigate('/mail-form/');
                    }}
                  >
                    お問い合わせ
                  </Box>
                  {renderMenuItems()}
                  <Box 
                    className="menu-item"
                    onClick={() => {
                      const user = JSON.parse(localStorage.getItem('user') || '{}');
                      const mypage = user?.mypage_url;

                      handleScrollTo('news', mypage);
                    }}
                  >
                    お知らせ
                  </Box>
                  <Box
                    className="menu-item"
                    onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
                  >
                    個人情報保護方針
                  </Box>
                </Box>
              </Box>
              <BackButton />
            </Container>
            <HamburgerMenu />
            </>
          )}
          {!!changeModalOpen &&(
            <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
              <Typography variant="h6" gutterBottom>
                修正内容のメモ
              </Typography>
              <TextField
                multiline
                rows={20}
                fullWidth
                placeholder="ここに修正内容を書いてください..."
                value={memoText}
                onChange={(e) => setMemoText(e.target.value)}
              />
              <Box>
                <Typography variant="h6">マイページ情報</Typography>
                {mypageData ? (
                  <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                    <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                    <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                    <Typography variant="body1">部署: {mypageData.department}</Typography>
                    <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                    <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                    <Typography variant="body1">住所: {mypageData.address}</Typography>
                    <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                    <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                  </Box>
                ) : (
                  <Typography variant="body2">読み込み中...</Typography>
                )}
              </Box>
            </Box>
          )}
          <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
            <Typography variant="h6">床面工事施工申込</Typography>
          <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
              <FormControlLabel
              control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
              label="申請しない"
              />

              {!notApply && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.user_4_info}
                          onChange={handleCorrectionChange( 'user_4_info')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="担当者情報"
                    />
                  )}
                  <Typography variant="h6" gutterBottom>
                  担当者情報
                  </Typography>
                  <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                  <FormControl component="fieldset">
                  <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                  <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                      <FormControlLabel value="same" control={<Radio />} label="同じ" />
                      <FormControlLabel value="different" control={<Radio />} label="異なる" />
                  </RadioGroup>
                  </FormControl>
                  <Grid container spacing={2}>
                  <Grid size={6}><TextField fullWidth label="氏名" name="user_4_name" value={formData.user_4_name} onChange={handleChange("user_4_name")} disabled={fieldsDisabled} error={!!submitErrors.user_4_name} helperText={submitErrors.user_4_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="部署" name="user_4_department" value={formData.user_4_department} onChange={handleChange("user_4_department")} disabled={fieldsDisabled} error={!!submitErrors.user_4_department} helperText={submitErrors.user_4_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_4_phone" value={formData.user_4_phone} onChange={handleChange("user_4_phone")} disabled={fieldsDisabled} error={!!submitErrors.user_4_phone} helperText={submitErrors.user_4_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_4_tel" value={formData.user_4_tel} onChange={handleChange("user_4_tel")} disabled={fieldsDisabled} error={!!submitErrors.user_4_tel} helperText={submitErrors.user_4_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  </Grid>
                  <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.invoice_info}
                          onChange={handleCorrectionChange( 'invoice_info')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="請求先情報"
                    />
                  )}

                  <Typography variant="h6" gutterBottom>
                  請求先情報
                  </Typography>
                  <FormControl component="fieldset">
                  <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                  <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                      <FormControlLabel value="same" control={<Radio />} label="同じ" />
                      <FormControlLabel value="different" control={<Radio />} label="異なる" />
                  </RadioGroup>
                  {user?.co_exhibit && sameAsInvoice === "different" && (
                    <Button
                      variant="outlined"
                      onClick={handleParentInvoiceClick}
                      disabled={loading}
                      style={{ marginBottom: "16px" }}
                    >
                      親出展者に請求する
                    </Button>
                  )}
                  </FormControl>
                  <Grid container spacing={2}>
                      <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} error={!!submitErrors.invoice_company_name} helperText={submitErrors.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} error={!!submitErrors.invoice_user_name} helperText={submitErrors.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} error={!!submitErrors.invoice_email} helperText={submitErrors.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} error={!!submitErrors.invoice_zip} helperText={submitErrors.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} error={!!submitErrors.invoice_address} helperText={submitErrors.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} error={!!submitErrors.invoice_tel} helperText={submitErrors.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                  </Grid>

                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.const_info}
                          onChange={handleCorrectionChange( 'const_info')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="工事情報"
                    />
                  )}

                  <Typography variant="h6" gutterBottom>
                  工事情報
                  </Typography>
                  <Typography variant="h7" gutterBottom>
                  アンカーボルト
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={4}><TextField fullWidth label="太さ(mm)" value={formData.bolt_thin} onChange={handleValidatedChange("bolt_thin",decimalValidator({ scale: 2, label: "太さ" }))} error={!!errors.bolt_thin} helperText={errors.bolt_thin} inputMode="decimal" slotProps={{ inputLabel: { shrink: true } }} /></Grid>
                    <Grid size={4}><TextField fullWidth label="深さ(mm)" value={formData.bolt_length} onChange={handleValidatedChange("bolt_length",decimalValidator({ scale: 2, label: "深さ" }))} error={!!errors.bolt_length} helperText={errors.bolt_length} inputMode="decimal" slotProps={{ inputLabel: { shrink: true } }} /></Grid>
                    <Grid size={4}><TextField fullWidth label="個数" value={formData.bolt_number} onChange={(e) => setFormData({ ...formData, bolt_number: Number(e.target.value) })} error={!!submitErrors.bolt_number} helperText={submitErrors.bolt_number} slotProps={{ inputLabel: { shrink: true }, formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},}, }}/></Grid>
                  </Grid>

                  {!!changeModalOpen &&(
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={corrections.contractor_info}
                          onChange={handleCorrectionChange( 'contractor_info')}
                          sx={{
                      color: 'red', // 未チェック時の枠の色
                      '&.Mui-checked': {
                        color: 'red', // チェック時の色
                      },
                    }}
                        />
                      }
                      label="施工業者情報"
                    />
                  )}

                  <Typography variant="h6">施工業者</Typography>
                  <Grid container spacing={2}>
                      <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="社名" value={formData.organize_company} onChange={(e) => setFormData({ ...formData, organize_company: e.target.value })} error={!!submitErrors.organize_company} helperText={submitErrors.organize_company} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="工事責任者" value={formData.organize_name} onChange={(e) => setFormData({ ...formData, organize_name: e.target.value })} error={!!submitErrors.organize_name} helperText={submitErrors.organize_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.organize_zip} onChange={(e) => setFormData({ ...formData, organize_zip: e.target.value })} error={!!submitErrors.organize_zip} helperText={submitErrors.organize_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={12}><TextField fullWidth label="住所" value={formData.organize_address} onChange={(e) => setFormData({ ...formData, organize_address: e.target.value })} error={!!submitErrors.organize_address} helperText={submitErrors.organize_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                      <Grid size={6}><TextField fullWidth label="電話番号" value={formData.organize_tel} onChange={(e) => setFormData({ ...formData, organize_tel: e.target.value })} error={!!submitErrors.organize_tel} helperText={submitErrors.organize_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                  </Grid>

                  <Typography variant="h6">備考欄</Typography>
                  <Typography color="error">※床面工事施工申込について補足事項がある場合はコチラにご入力ください。</Typography>
                  <TextField fullWidth multiline rows={4} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
              </Box>
              )}
          </FormGroup>
          <div style={{padding: '15px'}}></div>
          <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
            <Typography>
              【上記入力内容についてのお問い合わせ先】<br />
              SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社　事業部内）<br />
              担当：佐野・三宅<br />
              TEL:052-561-5675<br />
              入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
              ※お急ぎの場合はお電話にてお問い合わせください。
            </Typography>
          </Box>
          </Container>
        </Container>
        
        {!isCorpModal && (
          <>
          <Container sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleSubmit(exhibitorId)}
            >
              提出する
            </Button>
          </Container>
          <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
            <DialogTitle>注意事項</DialogTitle>
            <DialogContent>
              <p>
                床面工事施工申込を申請する場合は、アンカーボルト打設位置を「ブース平面図」よりご提出ください。<br />
                ※搬入日に打設位置及び数量が変更となった場合は修正後の打設位置及び数量をご提出ください。ご提出いただいた内容をもとにご請求内容を確定します。
              </p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseNotice} color="primary">
                閉じる
              </Button>
            </DialogActions>
          </Dialog>
        <footer>
          <Typography>
            © 2026 THE MID-JAPAN ECONOMIST.
          </Typography>
         </footer>
         </>
         )}
         {!!changeModalOpen &&(
          <Box display="flex" justifyContent="center" gap={2} mt={2}>
            <Button 
              variant="contained" 
              color="error" 
              onClick={handleCorrection}
              disabled={memoText.trim() === ''}
            >
              修正
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleConfirm}
            >
              確認
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => setFormModalOpen(false)}
            >
              中断
            </Button>
          </Box>
         )}
      </div>
    );
};

export default Comp4Sub;